import {Component, EventEmitter, OnInit, Output} from "@angular/core";
import {ITCIMarketplaceListing, TCIApplicationCreateOption, TCITenantAppType, TCITenantSelectorType} from "@tci/common";
import {
    ITCICreateAppComponentInput,
    ITCICreateAppComponentOutput,
    TCITenantComponentInput,
    TCITenantComponentOutput
} from "../../../ng-tenant/tci-tenant-components";
import {AbstractTCITenantComponent} from "../../../ng-tenant/tci-tenant-component";

export class BaseCreateAppMarketplaceV2ComponentInput extends TCITenantComponentInput implements ITCICreateAppComponentInput {
    constructor(private type: TCITenantAppType, protected option: TCIApplicationCreateOption) {
        super();
    }

    /**
     * Get the component tenant type
     */
    getTenantType(): TCITenantAppType {
        return this.type;
    }

    /**
     * Get the component create option
     */
    getCreateOption(): TCIApplicationCreateOption {
        return this.option;
    }
}

export class BaseCreateAppMarketplaceV2ComponentOutput<E> extends TCITenantComponentOutput<E> implements ITCICreateAppComponentOutput<E> {
    constructor() {
        super();
    }
}

@Component({
    selector: TCITenantSelectorType.TCI_APP_CREATE_MARKETPLACE.toString(),
    template: "<ng-marketplace-v2-mini [tenantAppType]='this.input.tenantAppType' [mkTags]='this.input.mkTags' (output)='createMarketplaceApp($event)'></ng-marketplace-v2-mini>"
})
export class BaseCreateAppMarketplaceV2Component<E, I extends BaseCreateAppMarketplaceV2ComponentInput, O extends BaseCreateAppMarketplaceV2ComponentOutput<E>>
    extends AbstractTCITenantComponent<E, I, O>
    implements OnInit {
    @Output() output: any = new EventEmitter();
    constructor() {
        super();
    }

    ngOnInit(): void {
    }

    createMarketplaceApp($event: ITCIMarketplaceListing): void {
        this.output.emit($event);
    }
}
